// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const torterra: PokeData = {
  "id": 389,
  "name": "torterra",
  "height": 22,
  "weight": 3100,
  "base_experience": 236,
  "types": [
    PokeType.GRASS,
    PokeType.GROUND
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "bite",
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "razor-leaf",
    "sleep-powder",
    "earthquake",
    "withdraw",
    "curse",
    "giga-drain",
    "synthesis",
    "crunch",
    "leaf-blade",
    "leaf-storm",
    "wood-hammer",
    "bulldoze",
    "leafage",
    "headlong-rush"
  ],
  "moves": [
    "tackle",
    "bite",
    "razor-leaf",
    "earthquake",
    "curse",
    "synthesis",
    "crunch",
    "wood-hammer",
    "solar-beam",
    "mud-slap",
    "energy-ball",
    "bone-throw",
    "frenzy-plant"
  ],
  "evolution_chain": {
    "id": 203,
    "item": null,
    "species": [
      {
        "name": "turtwig",
        "order": 417,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "grotle",
        "order": 418,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 387,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "torterra",
        "order": 419,
        "types": [
          PokeType.GRASS,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 388,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 146,
    "speed": 86,
    "ability_power": 168
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
